import { connect } from 'react-redux';
import { withSagas } from 'decorators/Sagas/Sagas';
import { CANCEL_CHAT_FEATURE_ID, SUPPORT_CHAT_FEATURE_ID } from 'constants/chat';
import { selectUserLocale } from 'redux/modules/locale';
import { dashFeatureById } from 'redux/saga/entities/bound';
import { decorateWith } from 'helpers/decorator';
import { doLoadZendeskFlags, loadUserProfile, showNpsSurvey, watchChat } from './zendesk.saga';
import { ZendeskChatSDK } from './ZendeskChatSDK';

export const mapDispatchToProps = {
  loadUserProfile,
  showNpsSurvey,
};

export const mapStateToProps = state => ({
  isSupportChatOn: dashFeatureById.data(state, SUPPORT_CHAT_FEATURE_ID),
  isCancelChatOn: dashFeatureById.data(state, CANCEL_CHAT_FEATURE_ID),
  locale: selectUserLocale(state),
});

export const ZendeskChatSDKContainer = decorateWith(
  withSagas({
    load: doLoadZendeskFlags,
    watch: [watchChat],
  }),
  connect(mapStateToProps, mapDispatchToProps)
)(ZendeskChatSDK);
